const QuestionsArray = [
  {
    title: "Usu tractatos accommodare ei pri alii invidunt eu?",
    text: "Molestiae adolescens his cu, ius facete scripta ad, ea ferri fastidii iudicabit pri. Vim id soleat aliquip adipisci, at qui discere denique salutatus, no appareat abhorreant quo. ",
  },
  {
    title: "Mel nostro fabellas tractatos in?",
    text: "Eam soluta noluisse lobortis no, eos in nibh patrioque. Decore populo detracto eu has. Viderer prodesset expetendis ei mel. Graeco invidunt vel et, vis postea feugiat splendide at, velit voluptaria has ex. Suas numquam te cum. Eam eius democritum adipiscing te, wisi facilisi et qui.",
  },
  {
    title: "Mei ne eirmod omittam adipisci?",
    text: "Id sed labores dolorum veritus, falli aeque id vis. Aliquip aperiri facilisis ei eam, an eos agam vivendo platonem. Quo volumus scaevola te. Mei invenire erroribus ne, at sit diam docendi. Vix cu aeque molestiae, sed no persius nusquam postulant.",
  },
  {
    title: "No facilis molestie mei. Alia malis dolor nam ea?",
    text: "Viderer molestiae vim id, equidem oportere consulatu eu nam. Et solum verterem eleifend nam. Doming latine scriptorem ex nec, alii equidem vis eu. ",
  },
  {
    title: "Usu tractatos accommodare ei pri alii invidunt eu?",
    text: "Molestiae adolescens his cu, ius facete scripta ad, ea ferri fastidii iudicabit pri. Vim id soleat aliquip adipisci, at qui discere denique salutatus, no appareat abhorreant quo. ",
  },
  {
    title: "Mel nostro fabellas tractatos in?",
    text: "Eam soluta noluisse lobortis no, eos in nibh patrioque. Decore populo detracto eu has. Viderer prodesset expetendis ei mel. Graeco invidunt vel et, vis postea feugiat splendide at, velit voluptaria has ex. Suas numquam te cum. Eam eius democritum adipiscing te, wisi facilisi et qui.",
  },
  {
    title: "Mei ne eirmod omittam adipisci?",
    text: "Id sed labores dolorum veritus, falli aeque id vis. Aliquip aperiri facilisis ei eam, an eos agam vivendo platonem. Quo volumus scaevola te. Mei invenire erroribus ne, at sit diam docendi. Vix cu aeque molestiae, sed no persius nusquam postulant.",
  },
  {
    title: "No facilis molestie mei. Alia malis dolor nam ea?",
    text: "Viderer molestiae vim id, equidem oportere consulatu eu nam. Et solum verterem eleifend nam. Doming latine scriptorem ex nec, alii equidem vis eu. ",
  },
];

export default QuestionsArray;